/*
 * Blue Yonder GWP - turns a phrase in the EasyGift popup sub-heading into a link.
 * August Long Weekend Sale, Jul 30 11:00 ET - Aug 4 15:00 ET 2026.
 *
 * WHY THIS EXISTS: EasyGift builds its sub-heading with
 *   document.createTextNode(popupOptions.subHeadline)
 * which escapes markup, so a URL cannot be added from the EG admin field.
 * (Verified in cdn.506.io/eg/script.js - 23 createTextNode calls; the only two
 * innerHTML calls are a shadow-root <style> and a hardcoded SVG, neither a
 * merchant field.) This finds the phrase in EG's rendered copy and converts it
 * into a real anchor IN PLACE, so the sentence reads naturally and the phrase
 * is not duplicated.
 *
 * SCHEDULING: none here, deliberately. EG's rule schedule is the SINGLE source
 * of truth. This script can only act on a popup that EG has already rendered,
 * so a second date window here would protect against nothing - while adding a
 * real failure mode: if the two schedules ever drifted (a UTC/EDT slip, or the
 * EG schedule being moved without editing this file), the popup would appear on
 * launch day WITHOUT the link, silently. One gate, not two.
 *
 * SCOPE: linkify() only touches a popup matching popupMatch, so the cap / duck /
 * compass / hat rules can never pick up this link. (Today they are all
 * Action = "Auto add" and render no popup at all, but the guard is explicit.)
 * After the promo ends, revert this file to an empty stub.
 *
 * This REPLACES the earlier custom size-picker modal, retired now that EG's
 * native "Show a popup for customers to choose products" does that job.
 */
(function () {
  'use strict';

  var CONFIG = {
    // ---- SET THIS ---------------------------------------------------------
    // Leave null and the script does nothing at all (safe default).
    // Absolute EU storefront URL so "See full details" always opens the EU
    // Promotional Terms page (never NA www), including preview/QA on
    // marathon-watch-italy.myshopify.com.
    url: 'https://eu.marathonwatch.com/pages/promotional-terms-conditions',
    // -----------------------------------------------------------------------

    // Must match EG's sub-heading copy exactly (case-insensitive), minus any
    // trailing full stop. Currently: "...Extra Long (fits wrist sizes 6.75"- 9").
    // See full details."
    phrase: 'See full details',

    // Defaults to true on purpose: the link sits INSIDE the gift popup, so a
    // same-tab navigation would close the popup and lose the customer's strap
    // choice. Set false only if you want it to navigate away.
    newTab: true,

    popupMatch: /royal blue|blue yonder|free strap/i,
    linkId: 'gwp-subheadline-link',

    // EG renders the headline as <h2> and the sub-heading as <h3>, so both
    // inherit Marathon's theme heading styles: Antonio + text-transform:uppercase.
    // Mulish is already loaded on the storefront (the product names and SELECT
    // buttons use it), so no webfont needs adding.
    // NOTE: this only undoes CSS-applied caps. The HEADLINE text is typed in
    // capitals in EG's admin field, so it must be retyped there - no CSS can
    // lowercase it.
    styleId: 'gwp-popup-type-fix',
    css: '#aca-modal-headline,#aca-modal-subheadline{' +
         'font-family:Mulish,sans-serif !important;text-transform:none !important;}'
  };

  if (!CONFIG.url) { return; }

  function injectStyles() {
    if (document.getElementById(CONFIG.styleId)) { return; }
    var st = document.createElement('style');
    st.id = CONFIG.styleId;
    st.textContent = CONFIG.css;
    document.head.appendChild(st);
  }

  function linkify() {
    if (document.getElementById(CONFIG.linkId)) { return; }

    var sub = document.getElementById('aca-modal-subheadline');
    if (!sub) { return; }

    var modal = document.getElementById('aca-modal');
    if (!modal || !CONFIG.popupMatch.test(modal.textContent || '')) { return; }

    // EG renders the sub-heading as one text node; find the phrase within it.
    var node = null;
    var idx = -1;
    for (var i = 0; i < sub.childNodes.length; i++) {
      var n = sub.childNodes[i];
      if (n.nodeType !== 3) { continue; }
      idx = n.nodeValue.toLowerCase().indexOf(CONFIG.phrase.toLowerCase());
      if (idx !== -1) { node = n; break; }
    }
    if (!node) { return; }   // copy changed - leave it alone rather than guess

    var raw = node.nodeValue;
    var a = document.createElement('a');
    a.id = CONFIG.linkId;
    a.href = CONFIG.url;
    a.textContent = raw.substr(idx, CONFIG.phrase.length);  // preserve EG's casing
    a.style.textDecoration = 'underline';
    a.style.color = 'inherit';
    if (CONFIG.newTab) {
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
    }

    var frag = document.createDocumentFragment();
    frag.appendChild(document.createTextNode(raw.slice(0, idx)));
    frag.appendChild(a);
    frag.appendChild(document.createTextNode(raw.slice(idx + CONFIG.phrase.length)));
    sub.replaceChild(frag, node);
  }

  var observer = new MutationObserver(linkify);

  function start() {
    injectStyles();   // only targets #aca-* ids, which exist solely in EG popups
    observer.observe(document.body, { childList: true, subtree: true });
    linkify();        // in case a popup is already open
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
